import _definePage_default_0 from '/home/www/sites/dev.statdbs.local/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/www/sites/dev.statdbs.local/resources/js/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/home/www/sites/dev.statdbs.local/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_4 from '/home/www/sites/dev.statdbs.local/resources/js/pages/home.vue?definePage&vue'
import _definePage_default_5 from '/home/www/sites/dev.statdbs.local/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_6 from '/home/www/sites/dev.statdbs.local/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_7 from '/home/www/sites/dev.statdbs.local/resources/js/pages/pages/misc/coming-soon.vue?definePage&vue'
import _definePage_default_8 from '/home/www/sites/dev.statdbs.local/resources/js/pages/pages/misc/under-maintenance.vue?definePage&vue'
import _definePage_default_9 from '/home/www/sites/dev.statdbs.local/resources/js/pages/register.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/bet-history',
    /* internal name: 'bet-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'bet-history',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'bet-history-id',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/[id].vue'),
        /* no children */
      },
      {
        path: 'import',
        name: 'bet-history-import',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/import.vue'),
        /* no children */
      },
      {
        path: 'missing',
        name: 'bet-history-missing',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/missing.vue'),
        /* no children */
      },
      {
        path: 'source',
        name: 'bet-history-source',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/source.vue'),
        /* no children */
      },
      {
        path: 'stat',
        /* internal name: 'bet-history-stat' */
        /* no component */
        children: [
          {
            path: '',
            name: 'bet-history-stat',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bet-history/stat/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/bookmakers',
    /* internal name: 'bookmakers' */
    /* no component */
    children: [
      {
        path: '',
        name: 'bookmakers',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bookmakers/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'bookmakers-id',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/bookmakers/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/calc',
    /* internal name: 'calc' */
    /* no component */
    children: [
      {
        path: '',
        name: 'calc',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/calc/index.vue'),
        /* no children */
      },
      {
        path: 'margin',
        name: 'calc-margin',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/calc/margin.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/categories',
    /* internal name: 'categories' */
    /* no component */
    children: [
      {
        path: '',
        name: 'categories',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/index.vue'),
        /* no children */
      },
      {
        path: ':category',
        /* internal name: 'categories-category' */
        /* no component */
        children: [
          {
            path: '',
            name: 'categories-category',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/index.vue'),
            /* no children */
          },
          {
            path: 'competitions',
            /* internal name: 'categories-category-competitions' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-competitions',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/competitions/index.vue'),
                /* no children */
              },
              {
                path: ':competition',
                name: 'categories-category-competitions-competition',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/competitions/[competition].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'events',
            /* internal name: 'categories-category-events' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-events',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/events/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'eventsodds',
            /* internal name: 'categories-category-eventsodds' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-eventsodds',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/eventsodds/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'leagues',
            /* internal name: 'categories-category-leagues' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-leagues',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/leagues/index.vue'),
                /* no children */
              },
              {
                path: ':league',
                name: 'categories-category-leagues-league',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/leagues/[league].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'players',
            /* internal name: 'categories-category-players' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-players',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/players/index.vue'),
                /* no children */
              },
              {
                path: ':player',
                name: 'categories-category-players-player',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/players/[player].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'playersodds',
            /* internal name: 'categories-category-playersodds' */
            /* no component */
            children: [
              {
                path: '',
                name: 'categories-category-playersodds',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/categories/[category]/playersodds/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/coupons',
    /* internal name: 'coupons' */
    /* no component */
    children: [
      {
        path: '',
        name: 'coupons',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/coupons/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'coupons-id',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/coupons/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/events',
    /* internal name: 'events' */
    /* no component */
    children: [
      {
        path: '',
        name: 'events',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/events/index.vue'),
        /* no children */
      },
      {
        path: ':event',
        name: 'events-event',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/events/[event].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/eventsodds',
    /* internal name: 'eventsodds' */
    /* no component */
    children: [
      {
        path: '',
        name: 'eventsodds',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/eventsodds/index.vue'),
        /* no children */
      },
      {
        path: ':eventodds',
        name: 'eventsodds-eventodds',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/eventsodds/[eventodds].vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  _mergeRouteRecord(
  {
    path: '/home',
    name: 'home',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/home.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/match',
    name: 'match',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/match.vue'),
    /* no children */
  },
  {
    path: '/matches',
    /* internal name: 'matches' */
    /* no component */
    children: [
      {
        path: '',
        name: 'matches',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/matches/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/old',
    /* internal name: 'old' */
    /* no component */
    children: [
      {
        path: 'players',
        /* internal name: 'old-players' */
        /* no component */
        children: [
          {
            path: '',
            name: 'old-players',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/old/players/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'old-players-id',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/old/players/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/opponents',
    /* internal name: 'opponents' */
    /* no component */
    children: [
      {
        path: ':player-vs-:opponent',
        name: 'opponents-player-vs-opponent',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/opponents/[player]-vs-[opponent].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'misc',
        /* internal name: 'pages-misc' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'coming-soon',
            name: 'pages-misc-coming-soon',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/pages/misc/coming-soon.vue'),
            /* no children */
          },
  _definePage_default_7
  ),
  _mergeRouteRecord(
          {
            path: 'under-maintenance',
            name: 'pages-misc-under-maintenance',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/pages/misc/under-maintenance.vue'),
            /* no children */
          },
  _definePage_default_8
  )
        ],
      }
    ],
  },
  {
    path: '/player',
    name: 'player',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/player.vue'),
    /* no children */
  },
  {
    path: '/players',
    /* internal name: 'players' */
    /* no component */
    children: [
      {
        path: '',
        name: 'players',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/players/index.vue'),
        /* no children */
      },
      {
        path: ':player',
        /* internal name: 'players-player' */
        /* no component */
        children: [
          {
            path: ':tab?',
            name: 'players-player-tab?',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/players/[player]/[[tab]].vue'),
            /* no children */
          },
          {
            path: 'index0',
            name: 'players-player-index0',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/players/[player]/index0.vue'),
            /* no children */
          }
        ],
      },
      {
        path: ':player-vs-:opponent',
        name: 'players-player-vs-opponent',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/players/[player]-vs-[opponent].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: 'profile' */
    /* no component */
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/profile/index.vue'),
        /* no children */
      },
      {
        path: 'bookmarks',
        name: 'profile-bookmarks',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/profile/bookmarks.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/providers',
    /* internal name: 'providers' */
    /* no component */
    children: [
      {
        path: '',
        name: 'providers',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/index.vue'),
        /* no children */
      },
      {
        path: ':provider',
        /* internal name: 'providers-provider' */
        /* no component */
        children: [
          {
            path: ':tab?',
            name: 'providers-provider-tab?',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/[[tab]].vue'),
            /* no children */
          },
          {
            path: 'categories',
            /* internal name: 'providers-provider-categories' */
            /* no component */
            children: [
              {
                path: ':category',
                /* internal name: 'providers-provider-categories-category' */
                /* no component */
                children: [
                  {
                    path: ':view?',
                    name: 'providers-provider-categories-category-view?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/categories/[category]/[[view]].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'competitions',
            /* internal name: 'providers-provider-competitions' */
            /* no component */
            children: [
              {
                path: ':competition',
                /* internal name: 'providers-provider-competitions-competition' */
                /* no component */
                children: [
                  {
                    path: ':view(.*)?',
                    name: 'providers-provider-competitions-competition$view?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/competitions/[competition]/[[...view]].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'events',
            /* internal name: 'providers-provider-events' */
            /* no component */
            children: [
              {
                path: ':event',
                name: 'providers-provider-events-event',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/events/[event].vue'),
                /* no children */
              },
              {
                path: 'bid:eventBid',
                name: 'providers-provider-events-bid-event-bid',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/events/bid[eventBid].vue'),
                /* no children */
              },
              {
                path: 'index0',
                name: 'providers-provider-events-index0',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/events/index0.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'odds',
            /* internal name: 'providers-provider-odds' */
            /* no component */
            children: [
              {
                path: ':odds',
                name: 'providers-provider-odds-odds',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/odds/[odds].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'players',
            /* internal name: 'providers-provider-players' */
            /* no component */
            children: [
              {
                path: ':player',
                /* internal name: 'providers-provider-players-player' */
                /* no component */
                children: [
                  {
                    path: ':view(.*)?',
                    name: 'providers-provider-players-player$view?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/players/[player]/[[...view]].vue'),
                    /* no children */
                  },
                  {
                    path: 'vs-:opponent(.*)?',
                    /* internal name: 'providers-provider-players-player-vs$opponent?' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'providers-provider-players-player-vs$opponent?',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/players/[player]/vs-[[...opponent]]/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              }
            ],
          },
          {
            path: 'source',
            /* internal name: 'providers-provider-source' */
            /* no component */
            children: [
              {
                path: '',
                name: 'providers-provider-source',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/source/index.vue'),
                /* no children */
              },
              {
                path: ':object',
                /* internal name: 'providers-provider-source-object' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'providers-provider-source-object',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/source/[object]/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':id',
                    name: 'providers-provider-source-object-id',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/source/[object]/[id].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'sports',
            /* internal name: 'providers-provider-sports' */
            /* no component */
            children: [
              {
                path: ':sport',
                /* internal name: 'providers-provider-sports-sport' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'providers-provider-sports-sport',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':view(.*)?',
                    name: 'providers-provider-sports-sport$view?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/[[...view]].vue'),
                    /* no children */
                  },
                  {
                    path: 'competitions',
                    /* internal name: 'providers-provider-sports-sport-competitions' */
                    /* no component */
                    children: [
                      {
                        path: ':competition',
                        name: 'providers-provider-sports-sport-competitions-competition',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/competitions/[competition].vue'),
                        /* no children */
                      },
                      {
                        path: 'index0',
                        name: 'providers-provider-sports-sport-competitions-index0',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/competitions/index0.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'events',
                    /* internal name: 'providers-provider-sports-sport-events' */
                    /* no component */
                    children: [
                      {
                        path: 'bid:eventBid',
                        name: 'providers-provider-sports-sport-events-bid-event-bid',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/events/bid[eventBid].vue'),
                        /* no children */
                      },
                      {
                        path: 'index0',
                        name: 'providers-provider-sports-sport-events-index0',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/events/index0.vue'),
                        /* no children */
                      },
                      {
                        path: 'upcoming',
                        name: 'providers-provider-sports-sport-events-upcoming',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/events/upcoming.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'eventsodds',
                    /* internal name: 'providers-provider-sports-sport-eventsodds' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'providers-provider-sports-sport-eventsodds',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/eventsodds/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'players',
                    /* internal name: 'providers-provider-sports-sport-players' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'providers-provider-sports-sport-players',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/players/index.vue'),
                        /* no children */
                      },
                      {
                        path: ':player',
                        /* internal name: 'providers-provider-sports-sport-players-player' */
                        /* no component */
                        children: [
                          {
                            path: ':tab?',
                            name: 'providers-provider-sports-sport-players-player-tab?',
                            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/players/[player]/[[tab]].vue'),
                            /* no children */
                          }
                        ],
                      },
                      {
                        path: ':player-vs-:opponent',
                        name: 'providers-provider-sports-sport-players-player-vs-opponent',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/players/[player]-vs-[opponent].vue'),
                        /* no children */
                      },
                      {
                        path: ':player2',
                        name: 'providers-provider-sports-sport-players-player2',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/players/[player2].vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'teams',
                    /* internal name: 'providers-provider-sports-sport-teams' */
                    /* no component */
                    children: [
                      {
                        path: ':player',
                        /* internal name: 'providers-provider-sports-sport-teams-player' */
                        /* no component */
                        children: [
                          {
                            path: ':tab?',
                            name: 'providers-provider-sports-sport-teams-player-tab?',
                            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/teams/[player]/[[tab]].vue'),
                            /* no children */
                          }
                        ],
                      },
                      {
                        path: ':player-vs-:opponent',
                        name: 'providers-provider-sports-sport-teams-player-vs-opponent',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/teams/[player]-vs-[opponent].vue'),
                        /* no children */
                      },
                      {
                        path: ':player2',
                        name: 'providers-provider-sports-sport-teams-player2',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/teams/[player2].vue'),
                        /* no children */
                      },
                      {
                        path: 'index0',
                        name: 'providers-provider-sports-sport-teams-index0',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/sports/[sport]/teams/index0.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              }
            ],
          },
          {
            path: 'teams',
            /* internal name: 'providers-provider-teams' */
            /* no component */
            children: [
              {
                path: ':team',
                /* internal name: 'providers-provider-teams-team' */
                /* no component */
                children: [
                  {
                    path: ':view(.*)?',
                    name: 'providers-provider-teams-team$view?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/teams/[team]/[[...view]].vue'),
                    /* no children */
                  },
                  {
                    path: 'vs-:opponent(.*)?',
                    /* internal name: 'providers-provider-teams-team-vs$opponent?' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'providers-provider-teams-team-vs$opponent?',
                        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/providers/[provider]/teams/[team]/vs-[[...opponent]]/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/register.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  {
    path: '/segments',
    /* internal name: 'segments' */
    /* no component */
    children: [
      {
        path: '',
        name: 'segments',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/index.vue'),
        /* no children */
      },
      {
        path: ':segment',
        /* internal name: 'segments-segment' */
        /* no component */
        children: [
          {
            path: '',
            name: 'segments-segment',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/index.vue'),
            /* no children */
          },
          {
            path: 'competitions',
            /* internal name: 'segments-segment-competitions' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-competitions',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/competitions/index.vue'),
                /* no children */
              },
              {
                path: ':competition',
                name: 'segments-segment-competitions-competition',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/competitions/[competition].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'events',
            /* internal name: 'segments-segment-events' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-events',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/events/index.vue'),
                /* no children */
              },
              {
                path: 'bid:eventBid',
                name: 'segments-segment-events-bid-event-bid',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/events/bid[eventBid].vue'),
                /* no children */
              },
              {
                path: 'upcoming',
                name: 'segments-segment-events-upcoming',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/events/upcoming.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'eventsodds',
            /* internal name: 'segments-segment-eventsodds' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-eventsodds',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/eventsodds/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'leagues',
            /* internal name: 'segments-segment-leagues' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-leagues',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/leagues/index.vue'),
                /* no children */
              },
              {
                path: ':league',
                name: 'segments-segment-leagues-league',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/leagues/[league].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'players',
            /* internal name: 'segments-segment-players' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-players',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/players/index.vue'),
                /* no children */
              },
              {
                path: ':player',
                /* internal name: 'segments-segment-players-player' */
                /* no component */
                children: [
                  {
                    path: ':tab?',
                    name: 'segments-segment-players-player-tab?',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/players/[player]/[[tab]].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: ':player-vs-:opponent',
                name: 'segments-segment-players-player-vs-opponent',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/players/[player]-vs-[opponent].vue'),
                /* no children */
              },
              {
                path: ':player2',
                name: 'segments-segment-players-player2',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/players/[player2].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'playersodds',
            /* internal name: 'segments-segment-playersodds' */
            /* no component */
            children: [
              {
                path: '',
                name: 'segments-segment-playersodds',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/playersodds/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'provider',
            /* internal name: 'segments-segment-provider' */
            /* no component */
            children: [
              {
                path: ':view(.*)?',
                name: 'segments-segment-provider$view?',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/provider/[[...view]].vue'),
                /* no children */
              },
              {
                path: 'index0',
                name: 'segments-segment-provider-index0',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/provider/index0.vue'),
                /* no children */
              },
              {
                path: 'teams',
                /* internal name: 'segments-segment-provider-teams' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'segments-segment-provider-teams',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/provider/teams/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'stat',
            name: 'segments-segment-stat',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/segments/[segment]/stat.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/servers',
    name: 'servers',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/servers.vue'),
    /* no children */
  },
  {
    path: '/source',
    /* internal name: 'source' */
    /* no component */
    children: [
      {
        path: '',
        name: 'source',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/index.vue'),
        /* no children */
      },
      {
        path: ':date',
        name: 'source-date',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/[date].vue'),
        /* no children */
      },
      {
        path: 'categories',
        /* internal name: 'source-categories' */
        /* no component */
        children: [
          {
            path: '',
            name: 'source-categories',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/index.vue'),
            /* no children */
          },
          {
            path: ':category',
            /* internal name: 'source-categories-category' */
            /* no component */
            children: [
              {
                path: '',
                name: 'source-categories-category',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[category]/index.vue'),
                /* no children */
              },
              {
                path: 'competitions',
                /* internal name: 'source-categories-category-competitions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'source-categories-category-competitions',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[category]/competitions/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':competition',
                    name: 'source-categories-category-competitions-competition',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[category]/competitions/[competition].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'events',
                name: 'source-categories-category-events',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[category]/events.vue'),
                /* no children */
              },
              {
                path: 'players',
                name: 'source-categories-category-players',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[category]/players.vue'),
                /* no children */
              }
            ],
          },
          {
            path: ':id',
            name: 'source-categories-id',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/categories/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'competitions',
        /* internal name: 'source-competitions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'source-competitions',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/competitions/index.vue'),
            /* no children */
          },
          {
            path: ':competition',
            name: 'source-competitions-competition',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/competitions/[competition].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'matches',
        /* internal name: 'source-matches' */
        /* no component */
        children: [
          {
            path: '',
            name: 'source-matches',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/matches/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'source-matches-id',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/matches/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'not-finished',
        name: 'source-not-finished',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/not-finished.vue'),
        /* no children */
      },
      {
        path: 'players',
        /* internal name: 'source-players' */
        /* no component */
        children: [
          {
            path: ':player',
            name: 'source-players-player',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/players/[player].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sports',
        /* internal name: 'source-sports' */
        /* no component */
        children: [
          {
            path: '',
            name: 'source-sports',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/index.vue'),
            /* no children */
          },
          {
            path: ':sport',
            /* internal name: 'source-sports-sport' */
            /* no component */
            children: [
              {
                path: '',
                name: 'source-sports-sport',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/index.vue'),
                /* no children */
              },
              {
                path: 'competitions',
                /* internal name: 'source-sports-sport-competitions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'source-sports-sport-competitions',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/competitions/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':competition',
                    name: 'source-sports-sport-competitions-competition',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/competitions/[competition].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'convertedplayers',
                /* internal name: 'source-sports-sport-convertedplayers' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'source-sports-sport-convertedplayers',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/convertedplayers/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':player',
                    name: 'source-sports-sport-convertedplayers-player',
                    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/convertedplayers/[player].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'events',
                name: 'source-sports-sport-events',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/events.vue'),
                /* no children */
              },
              {
                path: 'players',
                name: 'source-sports-sport-players',
                component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/sports/[sport]/players.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'tournaments',
        /* internal name: 'source-tournaments' */
        /* no component */
        children: [
          {
            path: '',
            name: 'source-tournaments',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/tournaments/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'source-tournaments-id',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/source/tournaments/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/sports',
    /* internal name: 'sports' */
    /* no component */
    children: [
      {
        path: '',
        name: 'sports',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/sports/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'sports-id',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/sports/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/storage',
    /* internal name: 'storage' */
    /* no component */
    children: [
      {
        path: '',
        name: 'storage',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/storage/index.vue'),
        /* no children */
      },
      {
        path: ':date',
        name: 'storage-date',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/storage/[date].vue'),
        /* no children */
      },
      {
        path: 'not-started',
        name: 'storage-not-started',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/storage/not-started.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test',
    /* internal name: 'test' */
    /* no component */
    children: [
      {
        path: 'parser',
        /* internal name: 'test-parser' */
        /* no component */
        children: [
          {
            path: '',
            name: 'test-parser',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/test/parser/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'parseregex',
        /* internal name: 'test-parseregex' */
        /* no component */
        children: [
          {
            path: '',
            name: 'test-parseregex',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/test/parseregex/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/tournaments',
    /* internal name: 'tournaments' */
    /* no component */
    children: [
      {
        path: '',
        name: 'tournaments',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/tournaments/index.vue'),
        /* no children */
      },
      {
        path: ':tournament',
        name: 'tournaments-tournament',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/tournaments/[tournament].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/uitest',
    name: 'uitest',
    component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/uitest.vue'),
    /* no children */
  },
  {
    path: '/users',
    /* internal name: 'users' */
    /* no component */
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/users/index.vue'),
        /* no children */
      },
      {
        path: ':user',
        /* internal name: 'users-user' */
        /* no component */
        children: [
          {
            path: ':view(.*)?',
            name: 'users-user$view?',
            component: () => import('/home/www/sites/dev.statdbs.local/resources/js/pages/users/[user]/[[...view]].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
